import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const PrivateRoute = () => {
  const { userLog } = useContext(AuthContext);
  return userLog ? <Navigate to="/" /> : <Outlet />;
};

export default PrivateRoute;
